import { useState } from "react";
import { format, parseISO } from "date-fns";
import { ar } from "date-fns/locale";
import { CalendarDays, X } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Calendar } from "@/components/ui/calendar";

const toStr = (d) => (d ? format(d, "yyyy-MM-dd") : "");
const RDP = {
  caption_dropdowns: "flex gap-2 justify-center",
  caption_label: "hidden",
  dropdown: "rounded-lg border border-slate-200 bg-white px-2 py-1 text-sm font-bold text-brand",
  vhidden: "hidden",
  nav_button_previous: "absolute right-1",
  nav_button_next: "absolute left-1",
  head_cell: "text-slate-500 rounded-md w-9 font-bold text-[0.75rem]",
  day: "h-9 w-9 p-0 rounded-lg font-bold hover:bg-brand-soft aria-selected:opacity-100",
  day_selected: "!bg-brand !text-white hover:!bg-brand",
  day_today: "ring-2 ring-brand/40 text-brand",
};

export default function DateInput({ value, onChange, testid, className = "field", placeholder = "اختر التاريخ" }) {
  const [open, setOpen] = useState(false);
  const d = value ? parseISO(value) : undefined;
  const emit = (v) => onChange({ target: { value: v } });
  const y = new Date().getFullYear();
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testid} className={`${className} flex items-center justify-between gap-2 text-right`}>
          <span className={d ? "text-slate-900" : "text-slate-400"}>{d ? format(d, "d MMMM yyyy", { locale: ar }) : placeholder}</span>
          <span className="flex items-center gap-1 shrink-0">
            {d && <X data-testid={`${testid}-clear`} className="w-4 h-4 text-slate-400 hover:text-red-600" onClick={(e) => { e.stopPropagation(); emit(""); }} />}
            <CalendarDays className="w-5 h-5 text-brand" />
          </span>
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0 rounded-2xl" align="start" data-testid={`${testid}-calendar`}>
        <Calendar mode="single" dir="rtl" locale={ar} selected={d} defaultMonth={d} weekStartsOn={6}
          captionLayout="dropdown-buttons" fromYear={y - 15} toYear={y + 15} classNames={RDP}
          onSelect={(x) => { emit(toStr(x)); setOpen(false); }} />
      </PopoverContent>
    </Popover>
  );
}
